import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';

const Navbar = ({ onBookNow }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // If on home page, scroll to section
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
      }
    } else {
      // Navigate to home page with scroll target
      navigate('/', { state: { scrollTo: sectionId } });
      setIsMobileMenuOpen(false);
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="https://static.wixstatic.com/media/f1e95d_bd3da2d723c5414bbf05fd6cc2f28086~mv2.png" 
              alt="YYC Pick-Up: Delivery & Hauling Services" 
              className="h-24 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => handleNavigation('/')} className="text-gray-300 hover:text-[#d4af37] transition">
              Home
            </button>
            <button onClick={() => handleNavigation('/services')} className="text-gray-300 hover:text-[#d4af37] transition">
              Services
            </button>
            <button onClick={() => handleNavigation('/testimonials')} className="text-gray-300 hover:text-[#d4af37] transition">
              Testimonials
            </button>
            <button onClick={() => handleNavigation('/blogs')} className="text-gray-300 hover:text-[#d4af37] transition">
              Blogs
            </button>
            <button onClick={() => handleNavigation('/contact')} className="text-gray-300 hover:text-[#d4af37] transition">
              Contact
            </button>
            <button 
              onClick={() => onBookNow()}
              className="bg-[#d4af37] text-black px-6 py-2 rounded-lg font-semibold hover:bg-[#b8941f] transition"
              data-testid="navbar-book-button"
            >
              Book Now
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-300 hover:text-[#d4af37]"
              data-testid="mobile-menu-toggle"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-sm" data-testid="mobile-menu">
          <div className="px-4 pt-2 pb-6 space-y-4">
            <button onClick={() => handleNavigation('/')} className="block w-full text-left text-gray-300 hover:text-[#d4af37] py-2">
              Home
            </button>
            <button onClick={() => handleNavigation('/services')} className="block w-full text-left text-gray-300 hover:text-[#d4af37] py-2">
              Services
            </button>
            <button onClick={() => handleNavigation('/testimonials')} className="block w-full text-left text-gray-300 hover:text-[#d4af37] py-2">
              Testimonials
            </button>
            <button onClick={() => handleNavigation('/blogs')} className="block w-full text-left text-gray-300 hover:text-[#d4af37] py-2">
              Blogs
            </button>
            <button onClick={() => handleNavigation('/contact')} className="block w-full text-left text-gray-300 hover:text-[#d4af37] py-2">
              Contact
            </button>
            <button 
              onClick={() => onBookNow()}
              className="w-full bg-[#d4af37] text-black px-6 py-3 rounded-lg font-semibold hover:bg-[#b8941f] transition"
            >
              Book Now
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;